<template>
  <div class="error-page">    
    <main class="error-content">
      <div class="container">
        <div class="error-illustration">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">
            <circle cx="400" cy="300" r="200" fill="rgba(10, 31, 61, 0.06)"/>
            <path fill="rgba(212, 175, 55, 0.95)" d="M400,150c-82.8,0-150,67.2-150,150s67.2,150,150,150s150-67.2,150-150S482.8,150,400,150z M430,450h-60v-60h60V450z M430,360h-60l15-150h30L430,360z"/>
          </svg>
        </div>
        
        <div class="error-details text-center">
          <h1 class="error-code">404</h1>
          <h2 class="error-title">Page introuvable</h2>
        
          
          <div class="action-buttons">
            <router-link to="/" class="btn-brand btn-brand--primary">
              Retour à l’accueil
            </router-link>
            <button type="button" @click="goBack" class="btn-brand btn-brand--secondary">
              Retour en arrière
            </button>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.error-page {
  display: flex;
  flex-direction: column;
  min-height: 80vh;
  background:
    radial-gradient(1200px 600px at 20% 0%, color-mix(in srgb, var(--bank-gold) 14%, transparent), transparent 60%),
    radial-gradient(900px 500px at 90% 20%, color-mix(in srgb, var(--bank-navy) 12%, transparent), transparent 55%),
    linear-gradient(180deg, var(--bank-gray-50), var(--bank-gray-50));
  color: var(--bank-gray-900);
  font-family: var(--font-body);
}

.error-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
}

.container {
  max-width: 1140px;
  padding: 0 15px;
}

.error-illustration {
  max-width: 300px;
  margin: 0 auto 2rem;
  animation: bounce 2s infinite alternate;
}

.error-details {
  padding: 0 1rem;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid color-mix(in srgb, var(--bank-navy) 10%, var(--bank-gray-200));
  border-radius: 1.25rem;
  box-shadow: var(--shadow-xl);
  padding: 2rem;
  backdrop-filter: blur(8px);
}

.error-code {
  font-size: 5rem;
  font-weight: 800;
  color: var(--bank-navy);
  margin-bottom: 0.5rem;
  line-height: 1;
}

.error-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: var(--bank-gray-800);
  margin-bottom: 1rem;
  font-family: var(--font-title);
  letter-spacing: var(--heading-letter-tight);
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  justify-content: center;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
  }
}

@media (max-width: 768px) {
  .error-content {
    padding: 1.25rem 0;
  }
  .error-code {
    font-size: 3.5rem;
  }
  
  .error-title {
    font-size: 2rem;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 420px) {
  .error-details {
    padding: 1.25rem;
  }
  .error-title {
    font-size: 1.6rem;
  }
}
</style>
